
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Subscription } from 'rxjs';
import { AccountEndpoint } from '../../../services/account-endpoint.service';
import { AccountService } from '../../../services/account.service';
import { DBkeys } from '../../../services/db-Keys';
import { GasService } from '../../../services/gas.service';
import { LocalStoreManager } from '../../../services/local-store-manager.service';
let _ = require('lodash');
require('chart.js');

@Component({
    selector: 'gas-statistics',
    template: require('./gas-statistics.component.html'),
    styles: [require('./gas-statistics.component.css')],
})
export class GasStatisticsComponent implements OnInit, OnDestroy {
    private subscribers: Subscription[] = [];

    @Input('monthsCount') monthsCount: number;
    gasStatistics: any;
    gasCount: number;
    suggestedMin: number = 10;
    suggestedMax: number = 20;
    Min: number = 10;
    Max: number = 20;
    chartData: Array<any> = [];
    chartLabels: Array<any> = [];
    chartOptions: any;
    chartColors: Array<any> = [
        {
            // Light red
            backgroundColor: 'rgba(255, 99, 132, 0.2)',
            borderColor: 'rgba(255, 99, 132, 1)',
            pointBackgroundColor: 'rgba(255, 99, 132, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(255, 99, 132, 0.8)'
        },
        {
            // Bright blue
            backgroundColor: 'rgba(54, 162, 235, 0.2)',
            borderColor: 'rgba(54, 162, 235, 1)',
            pointBackgroundColor: 'rgba(54, 162, 235, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(54, 162, 235, 0.8)'
        },
        {
            // Light orange
            backgroundColor: 'rgba(255, 206, 86, 0.2)',
            borderColor: 'rgba(255, 206, 86, 1)',
            pointBackgroundColor: 'rgba(255, 206, 86, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(255, 206, 86, 1)'
        },
        {
            // Moderate cyan
            backgroundColor: 'rgba(75, 192, 192, 0.2)',
            borderColor: 'rgba(75, 192, 192, 1)',
            pointBackgroundColor: 'rgba(75, 192, 192, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(75, 192, 192,0.8)'
        }
    ];
    chartLegend: boolean = true;
    chartType: string = 'line';
    loading: boolean = false;
    applicationVersionName: any;

    constructor(private gasService: GasService, private ngxLogger: NGXLogger, private storageManager: LocalStoreManager,
        private accountService: AccountService, private accountEndpoint: AccountEndpoint) { }

    ngOnInit() {
        this.loading = true;
        this.applicationVersionName = this.accountService.applicationVersionName;
        const gasStaSubscriber = this.gasService.getStatistics(this.monthsCount).subscribe((res: any) => {
            this.loading = false;
            if (res.Item2 && res.Item1 != null) {
                this.refreshChart(res.Item1, res.Item3);
            } else {
                let OChartData, OChartLabels, OMin, OMax;
                if (res.Item3) {
                    OChartData = this.storageManager.getchartData(this.storageManager.getApplicationVersion(DBkeys.APPLICATIONVERSION) + "_" + DBkeys.GASTRIALCHARTDATA);
                    OChartLabels = this.storageManager.getchartData(this.storageManager.getApplicationVersion(DBkeys.APPLICATIONVERSION) + "_" + DBkeys.GASTRIALCHARTLABELS);
                    OMin = this.storageManager.getMin(this.storageManager.getApplicationVersion(DBkeys.APPLICATIONVERSION) + "_" + DBkeys.GASTRIALMIN);
                    OMax = this.storageManager.getMax(this.storageManager.getApplicationVersion(DBkeys.APPLICATIONVERSION) + "_" + DBkeys.GASTRIALMAX);
                } else {
                    OChartData = this.storageManager.getchartData(this.storageManager.getApplicationVersion(DBkeys.APPLICATIONVERSION) + "_" + DBkeys.GASCHARTDATA);
                    OChartLabels = this.storageManager.getchartData(this.storageManager.getApplicationVersion(DBkeys.APPLICATIONVERSION) + "_" + DBkeys.GASCHARTLABELS);
                    OMin = this.storageManager.getMin(this.storageManager.getApplicationVersion(DBkeys.APPLICATIONVERSION) + "_" + DBkeys.GASMIN);
                    OMax = this.storageManager.getMax(this.storageManager.getApplicationVersion(DBkeys.APPLICATIONVERSION) + "_" + DBkeys.GASMAX);
                }
                if (OChartData != null && OChartLabels != null && OMin != null && OMax != null) {
                    this.refreshMemoryChart(OChartData, OChartLabels, OMin, OMax);
                } else if (OChartData == null || OChartLabels == null || OMin == null || OMax == null) {
                    this.gasService.getCacheStatistics(this.monthsCount).subscribe((res: any) => {
                        if (res.Item1 != null) {
                            this.refreshChart(res.Item1, res.Item2);
                        }
                    });
                }

            }
        }, error => {
            this.loading = false;
            this.ngxLogger.error(error.message);
            throw error;
        });

        this.subscribers.push(gasStaSubscriber);
    }

    refreshChart(res, trial) {

        let temp = _(res)
            .map((value, key) => ({ Data: value.SettlementPrice }))
            .value();

        this.Max = Math.max.apply(Math, temp.map(function (o) { return o.Data; }));
        this.Min = Math.min.apply(Math, temp.map(function (o) { return o.Data; }));

        this.gasStatistics = _(res).groupBy(x => x.StripName)
            .map((value, key) => ({ StripName: key, Data: value }))
            .value();

        // creates an array of the `value` property: [100, 22, 12]
        let numbers = this.gasStatistics.map(i => i.Data.length);
        // gets the sum of the array of numbers: 134
        this.gasCount = numbers.reduce((a, b) => a + b, 0);

        this.loading = false;

        if (this.gasStatistics != null && this.gasStatistics !== undefined && this.gasStatistics.length > 0) {
            let _chartData: Array<any> = [{ data: new Array(this.gasStatistics.length) }];
            let _chartLabels: Array<any> = new Array(this.gasStatistics[0].Data.length);
            _chartLabels = _.map(this.gasStatistics[0].Data, 'Datum');
            for (let i = 0; i < this.gasStatistics.length; i++) {
                _chartData[i] = { data: new Array(this.gasStatistics[i].Data.length), label: this.gasStatistics[i].StripName };
                for (let j = 0; j < this.gasStatistics[i].Data.length; j++) {
                    _chartData[i].data[j] = this.gasStatistics[i].Data[j].SettlementPrice;
                }
            }

            this.chartData = _chartData;
            this.chartLabels = _chartLabels;

            this.chartOptions = {
                responsive: true,
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            suggestedMin: this.suggestedMin,
                            suggestedMax: this.suggestedMax,
                            min: this.Min,
                            max: this.Max
                        }
                    }]
                },
                elements: {
                    line: {
                        fill: false
                    },
                    point: {
                        radius: 0
                    }
                }
            };

            if (this.applicationVersionName == null || this.applicationVersionName == undefined) {
                this.accountEndpoint.getApplicationVersionName().subscribe(res => {
                    this.applicationVersionName = res;
                    this.GetdataLocalSt(trial, _chartData, _chartLabels);
                });
            } else {
                this.storageManager.setApplicationVersion(this.applicationVersionName, DBkeys.APPLICATIONVERSION);
                this.GetdataLocalSt(trial, _chartData, _chartLabels);
            }
        }
    }

    GetdataLocalSt(trial, _chartData, _chartLabels) {
        if (trial) {
            this.storageManager.setchartData(_chartData, this.applicationVersionName + "_" + DBkeys.GASTRIALCHARTDATA);
            this.storageManager.setchartLabels(_chartLabels, this.applicationVersionName + "_" + DBkeys.GASTRIALCHARTLABELS);
            this.storageManager.setMax(this.Max, this.applicationVersionName + "_" + DBkeys.GASTRIALMAX);
            this.storageManager.setMin(this.Min, this.applicationVersionName + "_" + DBkeys.GASTRIALMIN);

        } else {
            this.storageManager.setchartData(_chartData, this.applicationVersionName + "_" + DBkeys.GASCHARTDATA);
            this.storageManager.setchartLabels(_chartLabels, this.applicationVersionName + "_" + DBkeys.GASCHARTLABELS);
            this.storageManager.setMax(this.Max, this.applicationVersionName + "_" + DBkeys.GASMAX);
            this.storageManager.setMin(this.Min, this.applicationVersionName + "_" + DBkeys.GASMIN);
        }
    }

    refreshMemoryChart(OChartData, OChartLabels, OMin, OMax) {

        this.gasStatistics = OChartData;
        this.chartData = OChartData;
        this.chartLabels = OChartLabels;
        this.Min = OMin;
        this.Max = OMax;
        this.chartOptions = {
            responsive: true,
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                        suggestedMin: this.suggestedMin,
                        suggestedMax: this.suggestedMax,
                        min: this.Min,
                        max: this.Max
                    }
                }]
            },
            elements: {
                line: {
                    fill: false
                },
                point: {
                    radius: 0
                }
            }
        };
    }

    ngOnDestroy() {
        if (this.subscribers) {
            this.subscribers.forEach(s => s.unsubscribe());
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/gas/gas-statistics/gas-statistics.component.ts